// extracted by mini-css-extract-plugin
export default {"samplePage":"WidgetSamplePage-samplePage-1WYm6","bgImg":"WidgetSamplePage-bgImg-3rZe2"};